import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageHeader, ContentNav } from '../organization-detail/components'
import { Container } from '../../components'
import { MainContent, MainContentMobile } from '../blog/components'
import organizations from '../../database/organizations'

const OrganizationDetailBlog = ({match}) => {
  const id = match.params.id
  const organization = organizations.find(o => o.id === parseInt(id))

  return (
    <DefaultLayout>
      <PageHeader data={organization}/>
      <div className="mb-5 lg:hidden">
        <ContentNav organization={organization} route="Blog" mobile/>
      </div>
      <Container>
        <div className="py-8 mb-8 hidden lg:block">
          <ContentNav route="Blog" organization={organization}/>
        </div>
      </Container>
      <div className="lg:hidden">
        <MainContentMobile uniform={true} embed={true} byId={true} blogIds={organization.blogs}/>
      </div>
      <MainContent uniform={true} embed={true} byId={true} blogIds={organization.blogs}/>
    </DefaultLayout>
  )
}

export { OrganizationDetailBlog }